// extracted by mini-css-extract-plugin
export default {"Header":"LoginHeader_Header__NQ2BV"};